// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/sources/ImportSourcesModalUploaderItem.scss
// module id = 1324
// module chunks = 0